'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var dayjs = require('dayjs');
var performance = require('perf_hooks').performance;
var AbstractDriver = require('../abstract');
var Attribute = require('./attribute');
var DataTypes = require('./data_types');
var _a = require('./sqlstring'), escapeId = _a.escapeId, escape = _a.escape, alterTableWithChangeColumn = _a.alterTableWithChangeColumn, parseDefaultValue = _a.parseDefaultValue;
var Spellbook = require('./spellbook');
var Pool = require('./pool');
var calculateDuration = require('../../utils').calculateDuration;
var heresql = require('../../utils/string').heresql;
var SqliteDriver = /** @class */ (function (_super) {
    __extends(SqliteDriver, _super);
    function SqliteDriver(opts) {
        if (opts === void 0) { opts = {}; }
        var _this = _super.call(this, opts) || this;
        _this.type = 'sqlite';
        _this.pool = _this.createPool(opts);
        _this.Attribute = _this.constructor.Attribute;
        _this.DataTypes = _this.constructor.DataTypes;
        _this.spellbook = new _this.constructor.Spellbook();
        _this.escape = escape;
        _this.escapeId = escapeId;
        return _this;
    }
    SqliteDriver.prototype.createPool = function (opts) {
        return new Pool(opts);
    };
    SqliteDriver.prototype.getConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pool.getConnection()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SqliteDriver.prototype.query = function (query, values, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var connection, _a, logger, logOpts, sql, start, result, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = opts.connection;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getConnection()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        connection = _a;
                        // node-sqlite3 does not support Date as parameterized value
                        if (values) {
                            values = values.map(function (entry) {
                                if (entry instanceof Date) {
                                    return dayjs(entry).format('YYYY-MM-DD HH:mm:ss.SSS Z');
                                }
                                return entry;
                            });
                        }
                        logger = this.logger;
                        logOpts = __assign(__assign({}, opts), { query: query });
                        sql = logger.format(query, values, opts);
                        start = performance.now();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, 6, 7]);
                        return [4 /*yield*/, connection.query(query, values, opts)];
                    case 4:
                        result = _b.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _b.sent();
                        logger.logQueryError(err_1, sql, calculateDuration(start), logOpts);
                        throw err_1;
                    case 6:
                        if (!opts.connection)
                            connection.release();
                        return [7 /*endfinally*/];
                    case 7:
                        logger.tryLogQuery(sql, calculateDuration(start), logOpts, result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SqliteDriver.prototype.querySchemaInfo = function (database, tables) {
        return __awaiter(this, void 0, void 0, function () {
            var queries, results, schemaInfo, rColumnType, rDateType, i, table, rows, columns;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tables = [].concat(tables);
                        queries = tables.map(function (table) {
                            return _this.query("PRAGMA table_info(".concat(_this.escapeId(table), ")"));
                        });
                        return [4 /*yield*/, Promise.all(queries)];
                    case 1:
                        results = _a.sent();
                        schemaInfo = {};
                        rColumnType = /^(\w+)(?:\(([^)]+)\))?/i;
                        rDateType = /(?:date|datetime|timestamp)/i;
                        for (i = 0; i < tables.length; i++) {
                            table = tables[i];
                            rows = results[i].rows;
                            columns = rows.map(function (row) {
                                var name = row.name, type = row.type, notnull = row.notnull, dflt_value = row.dflt_value, pk = row.pk;
                                var columnType = type.toLowerCase();
                                var _a = __read(columnType.match(rColumnType), 3), dataType = _a[1], precision = _a[2];
                                var primaryKey = pk === 1;
                                var result = {
                                    columnName: name,
                                    columnType: columnType,
                                    defaultValue: parseDefaultValue(dflt_value, type),
                                    dataType: dataType,
                                    allowNull: primaryKey ? false : notnull == 0,
                                    primaryKey: primaryKey,
                                    datetimePrecision: rDateType.test(dataType) ? parseInt(precision, 10) : null,
                                };
                                return result;
                            });
                            if (columns.length > 0)
                                schemaInfo[table] = columns;
                        }
                        return [2 /*return*/, schemaInfo];
                }
            });
        });
    };
    SqliteDriver.prototype.createTable = function (table, attributes, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var chunks, columns;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chunks = ["CREATE TABLE ".concat(escapeId(table))];
                        columns = Object.keys(attributes).map(function (name) {
                            var attribute = new _this.constructor.Attribute(name, attributes[name]);
                            return attribute.toSqlString();
                        });
                        chunks.push("(".concat(columns.join(', '), ")"));
                        return [4 /*yield*/, this.query(chunks.join(' '), [], opts)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SqliteDriver.prototype.alterTable = function (table, changes) {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, attributes, attributes_1, attributes_1_1, attribute, columnName, e_1_1;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        chunks = ["ALTER TABLE ".concat(escapeId(table))];
                        attributes = Object.keys(changes).map(function (name) {
                            var options = changes[name];
                            if (options.remove)
                                return { columnName: name, remove: true };
                            return new _this.constructor.Attribute(name, changes[name]);
                        });
                        if (!attributes.some(function (entry) { return entry.modify || entry.primaryKey; })) return [3 /*break*/, 2];
                        return [4 /*yield*/, alterTableWithChangeColumn(this, table, attributes)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                    case 2:
                        _b.trys.push([2, 9, 10, 11]);
                        attributes_1 = __values(attributes), attributes_1_1 = attributes_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!attributes_1_1.done) return [3 /*break*/, 8];
                        attribute = attributes_1_1.value;
                        if (!attribute.remove) return [3 /*break*/, 5];
                        columnName = attribute.columnName;
                        return [4 /*yield*/, this.query(chunks.concat("DROP COLUMN ".concat(this.escapeId(columnName))).join(' '))];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.query(chunks.concat("ADD COLUMN ".concat(attribute.toSqlString())).join(' '))];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        attributes_1_1 = attributes_1.next();
                        return [3 /*break*/, 3];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (attributes_1_1 && !attributes_1_1.done && (_a = attributes_1.return)) _a.call(attributes_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    SqliteDriver.prototype.addColumn = function (table, name, params) {
        return __awaiter(this, void 0, void 0, function () {
            var attribute, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attribute = new this.constructor.Attribute(name, params);
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), "\n      ADD COLUMN ").concat(attribute.toSqlString(), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SqliteDriver.prototype.changeColumn = function (table, name, params) {
        return __awaiter(this, void 0, void 0, function () {
            var attribute, schemaInfo, columns, columns_1, columns_1_1, entry;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        attribute = new this.Attribute(name, params);
                        return [4 /*yield*/, this.querySchemaInfo(null, table)];
                    case 1:
                        schemaInfo = _b.sent();
                        columns = schemaInfo[table];
                        try {
                            for (columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                                entry = columns_1_1.value;
                                if (entry.columnName === attribute.columnName) {
                                    Object.assign(entry, attribute, { modify: true });
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [4 /*yield*/, this.alterTable(table, columns)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SqliteDriver.prototype.removeColumn = function (table, name) {
        return __awaiter(this, void 0, void 0, function () {
            var attribute, changes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attribute = new this.Attribute(name);
                        attribute.remove = true;
                        changes = [attribute];
                        return [4 /*yield*/, alterTableWithChangeColumn(this, table, changes)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * SQLite has only got implicit table truncation.
     * - https://sqlite.org/lang_delete.html#the_truncate_optimization
     */
    SqliteDriver.prototype.truncateTable = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.query("DELETE FROM ".concat(escapeId(table)))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // define static properties as this way IDE will prompt
    SqliteDriver.Spellbook = Spellbook;
    SqliteDriver.Attribute = Attribute;
    SqliteDriver.DataTypes = DataTypes;
    return SqliteDriver;
}(AbstractDriver));
;
module.exports = SqliteDriver;
//# sourceMappingURL=index.js.map